import React from "react";
import { isEmail } from "validator";

const email = (value) => {
  if (!isEmail(value)) {
    return <div role="alert">Email not valid</div>;
  }
};

export default email;
